import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';

const PrivacyPolicy = () => (
  <>
    <SEOHead
      title="Privacy Policy - WorldCup Fan Planner"
      description="How WorldCup Fan Planner collects, uses, and protects your information, including cookies and advertising (Google AdSense)."
    />
    <div className="max-w-3xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">Privacy Policy</h1>
      <p className="text-sm text-gray-500 dark:text-gray-400 mb-8">Last updated: March 2026</p>

      <section className="space-y-4 text-gray-700 dark:text-gray-300">
        <p>
          WorldCup Fan Planner (&quot;we&quot;, &quot;us&quot;) operates this website to help fans plan travel and follow the FIFA World Cup. This policy describes how we handle information when you use our site.
        </p>

        <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-8">Information we collect</h2>
        <p>
          We may collect information you submit through forms (for example, fan meetup or planner fields), technical data such as browser type and approximate region from server logs, and usage data through analytics or advertising partners as described below.
        </p>

        <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-8">Cookies and similar technologies</h2>
        <p>
          We use cookies and similar technologies to operate the site, remember preferences where applicable, and to show relevant advertising. Third-party services (including Google) may set their own cookies when you use our pages.
        </p>

        <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-8">Advertising (Google AdSense)</h2>
        <p>
          Third-party vendors, including Google, use cookies to serve ads based on your prior visits to this or other websites. Google&apos;s use of advertising cookies enables it and its partners to serve ads to you based on your visit to our site and/or other sites on the Internet. You may opt out of personalized advertising by visiting{' '}
          <a href="https://www.google.com/settings/ads" className="text-amber-600 dark:text-amber-400 hover:underline" target="_blank" rel="noopener noreferrer">
            Google Ads Settings
          </a>
          {' '}or{' '}
          <a href="https://www.aboutads.info" className="text-amber-600 dark:text-amber-400 hover:underline" target="_blank" rel="noopener noreferrer">
            aboutads.info
          </a>
          .
        </p>

        <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-8">How we use information</h2>
        <p>
          We use collected information to provide and improve our services, respond to requests, analyze traffic, and show advertisements where enabled.
        </p>

        <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-8">Children</h2>
        <p>
          Our site is not directed at children under 13, and we do not knowingly collect personal information from children.
        </p>

        <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-8">Changes</h2>
        <p>
          We may update this policy from time to time. Continued use of the site after changes constitutes acceptance of the updated policy.
        </p>

        <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-8">Contact</h2>
        <p>
          For privacy-related questions, please use the contact options provided on our site, if any, or reach out through your hosting or domain provider&apos;s listed contacts for this property.
        </p>

        <p className="pt-6">
          <Link to="/" className="text-amber-600 dark:text-amber-400 hover:underline">← Back to home</Link>
        </p>
      </section>
    </div>
  </>
);

export default PrivacyPolicy;
